import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

interface DummyComponentProps {
  title: string;
}

const DummyComponent: React.FC<DummyComponentProps> = ({ title }) => {
  return (
    <Paper elevation={1} sx={{ p: 4, borderRadius: 3 }}>
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        This is the <strong>{title}</strong> content area. You can replace this with real content in production.
      </Typography>
    </Paper>
  );
};

export default DummyComponent;
